import { SET_MENUS_DATA } from "./types";

export function setMenusData(Data) {
    return {
        type: SET_MENUS_DATA,
        Data,
    };
};